import { useQuery } from '@tanstack/react-query';
import {
  getPostgresLogs,
  getPostgresProfilerSettings,
  getPostgresSlowQueries,
} from '../api';
import type { PostgresSlowQueriesFilters } from '../types';

export const postgresProfilerKeys = {
  all: ['postgres-profiler'] as const,
  settings: () => [...postgresProfilerKeys.all, 'settings'] as const,
  slowQueries: (filters: PostgresSlowQueriesFilters) =>
    [...postgresProfilerKeys.all, 'slow-queries', filters] as const,
  logs: (params: { limit?: number; tailBytes?: number }) =>
    [...postgresProfilerKeys.all, 'logs', params] as const,
};

export function usePostgresProfilerSettings() {
  return useQuery({
    queryKey: postgresProfilerKeys.settings(),
    queryFn: getPostgresProfilerSettings,
    staleTime: 30 * 1000,
  });
}

export function usePostgresSlowQueries(filters: PostgresSlowQueriesFilters) {
  return useQuery({
    queryKey: postgresProfilerKeys.slowQueries(filters),
    queryFn: () => getPostgresSlowQueries(filters),
    staleTime: 30 * 1000,
  });
}

export function usePostgresLogs(params: { limit?: number; tailBytes?: number }) {
  return useQuery({
    queryKey: postgresProfilerKeys.logs(params),
    queryFn: () => getPostgresLogs(params),
    staleTime: 30 * 1000,
  });
}
